/** マイグレーション初期グループ名（削除不可・新規マニュアルの既定選択） */
export const DEFAULT_MANUAL_GROUP_NAME = '未分類';

/** 一覧・検索の閲覧状態（最終編集者には常に read） */
export type ManualReadState = 'unread' | 'edited_since_read' | 'read';

/** GET /api/manual/manuals/recent の 1 行 */
export type ManualRecentItem = {
  id: number;
  group_id: number;
  group_name: string;
  title: string;
  updated_at: string;
  manual_read_state: ManualReadState;
  is_unread: boolean;
  last_edited_by: {
    staff_user_id: number;
    display_name: string;
  };
};

export type ManualRecentResponse = {
  manuals: ManualRecentItem[];
};

/** GET /api/manual/groups の 1 マニュアル行 */
export type ManualListItem = {
  id: number;
  title: string;
  updated_at: string;
  /** グループ内の表示順（0 から） */
  sort_order: number;
  current_version_ms: number;
  manual_read_state: ManualReadState;
  /** read 以外（未読・編集あり） */
  is_unread: boolean;
  last_edited_by: {
    staff_user_id: number;
    display_name: string;
  };
};

export type ManualGroupWithManuals = {
  id: number;
  name: string;
  sort_order: number;
  created_at: string;
  manuals: ManualListItem[];
};

export type ManualGroupsTreeResponse = {
  groups: ManualGroupWithManuals[];
};

/** GET /api/manual/search の 1 行（タイトル・本文でヒットしたマニュアル） */
export type ManualSearchResultItem = {
  id: number;
  group_id: number;
  group_name: string;
  title: string;
  updated_at: string;
  manual_read_state: ManualReadState;
  is_unread: boolean;
};

export type ManualSearchResponse = {
  results: ManualSearchResultItem[];
  total: number;
  page: number;
  limit: number;
  total_pages: number;
};

export type ManualAttachmentRow = {
  id: number;
  manual_id: number;
  s3_key: string;
  original_filename: string;
  content_type: string;
  byte_size: number;
  sort_order: number;
  created_at: string;
};

export type ManualReaderRow = {
  staff_user_id: number;
  display_name: string;
  reader_avatar_url: string | null;
  read_at: string;
};

export type ManualDetailResponse = {
  manual: {
    id: number;
    group_id: number;
    title: string;
    body: string;
    current_version_ms: number;
    created_at: string;
    updated_at: string;
    created_by: { staff_user_id: number; display_name: string };
    last_edited_by: { staff_user_id: number; display_name: string };
    attachments: ManualAttachmentRow[];
  };
  readers: ManualReaderRow[];
};

export type ManualAttachmentPayload = {
  s3_key: string;
  original_filename: string;
  content_type: string;
  byte_size: number;
};
